var lib_core = require("lib-core");

var DrawingElement = require("./drawingElement.js");

var RootGroup = function (gui, data, parentGroup) {
    var self = this;

    this.gui = gui;
    this.data = data;

    this.initGroups(parentGroup);

    this.inFocus = false;
};
lib_core.mixin(RootGroup, DrawingElement);

module.exports = RootGroup;
